import { Form } from "react-bootstrap";

/**
 * LateTasksFilter - Checkbox filter for "Late Tasks Only"
 * @param {Boolean} value - Whether filter is active
 * @param {Function} setValue - Setter for filter value
 */
const LateTasksFilter = ({ value, setValue }) => {
  return (
    <div style={{ maxWidth: 220, display: "flex", alignItems: "center" , justifyContent: "center"}}>
      <Form.Group
        className="mb-3"
        controlId="lateTasksCheckbox"
        style={{ marginTop: 8, display: "flex", alignItems: "center",justifyContent: "center", gap: 12 }}
      >
        <Form.Check
          type="checkbox"
          id="late-tasks-only"
          label="Late Tasks Only"
          checked={value}
          onChange={(e) => setValue(e.target.checked)}
          style={{ marginBottom: 0, whiteSpace: "nowrap", fontWeight: "bold" }}
        />
      </Form.Group>
    </div>
  );
};

export default LateTasksFilter;
